/* es5-ext/string/#/repeat/is-implemented.js */ function _(require, module, exports) {
    var str = "foo";
    module.exports = function () {
        if (typeof str.repeat !== "function")
            return false;
        return str.repeat(2) === "foofoo";
    };
}
